import { Injectable } from '@angular/core';
import { Line, LineDTO } from '../../models/line.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { environment } from '../../../../environments/environment';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';
import { RequestService } from '../request/request';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class LineService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'lines/';
  url = environment.service_1 + 'all-lines/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedline = new BehaviorSubject<Line | null>(null);
  selectedline$ = this.selectedline.asObservable();

  private lines = new BehaviorSubject<Line[]>([]);
  lines$ = this.lines.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setLine(line: Line) {
    this.selectedline.next(line);
  }

  setLines(lines: Line[]) {
    this.lines.next(lines);
  }

  removeLineSelected() {
    this.selectedline.next(null);
  }

  createLine(line: LineDTO) {
    return this.http.post<Line>(this.urlPath, line).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateLine(id: number, line: LineDTO & { id: number }) {
    return this.http.put<Line>(this.urlPath + id + '/', line).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getLine(query: QueryGet): Observable<Pagination<Line[]>> {
    return this.requestService.get<Line[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getLines(): Observable<Line[]> {
    return this.http.get<Line[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionLine(line: Line[]): OptionSelect[] {
    return line.map((item: Line) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
